import { Row } from "antd";
import { FormInstance } from "antd";
import { CriteriaOption } from "../../../../types/bulkEmails/CriteriaOption";
import { CriteriaRowModel } from "../../../../types/bulkEmails/CriteriaRowModel";
import { useState, useMemo, useCallback, useEffect } from "react";
import { CriteriaRow } from "./CriteriaRow";

export const CriteriaContainer = ({
  form,
  options,
  defaultCriteria,
  setRequest
}: {
  form: FormInstance;
  options: CriteriaOption[];
  defaultCriteria: Omit<CriteriaRowModel, "id">[];
  setRequest: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const [rows, setRows] = useState<CriteriaRowModel[]>(() =>
    defaultCriteria.map((x) => ({
      ...x,
      id: crypto.randomUUID()
    }))
  );

  const usedOptions = useMemo(() => rows.map((x) => x.optionKey).filter(Boolean) as string[], [rows]);

  const canAdd = useMemo(() => rows.length < options.length, [rows, options.length]);

  const updateRequest = useCallback(() => {
    setRequest(form.getFieldsValue());
  }, [form, setRequest]);

  useEffect(() => {
    updateRequest();
  }, [rows, updateRequest]);

  const updateRow = useCallback((row: CriteriaRowModel) => {
    setRows((previous) => previous.map((x) => (x.id === row.id ? row : x)));
  }, []);

  const deleteRow = useCallback((id: string) => {
    setRows((previous) => previous.filter((x) => x.id !== id));
  }, []);

  const addRow = useCallback(() => {
    setRows((previous) => [
      ...previous,
      {
        id: crypto.randomUUID(),
        optionKey: undefined,
        value: undefined,
        removable: true
      }
    ]);
  }, []);

  return (
    <>
      {rows.map((row) => (
        <CriteriaRow
          key={row.id}
          form={form}
          row={row}
          options={options}
          usedOptions={usedOptions}
          formKey={options.find((x) => x.key === row.optionKey)?.formKey || ""}
          onChange={updateRow}
          onRemove={() => deleteRow(row.id)}
        />
      ))}

      {canAdd && (
        <Row>
          <p className="mx-2 text-md w-500 logo-cursor ant-btn-link" onClick={addRow}>
            + Add Criteria
          </p>
        </Row>
      )}
    </>
  );
};
